import { SimpleModal, SimpleModalVariant } from "@repo/ui/Modal/modal";
import type { FC } from "react";
import { useDeleteToolMutation } from "../../api/entities/tool.js";
import { useAppDispatch } from "../../hooks/hook.js";
import {
  NotificationType,
  showNotification,
} from "../notificationsOverlay/notificationsSlice.js";

interface DeleteToolModalProps {
  isOpen: boolean;
  onClose: () => void;
  toolId: string;
  toolName: string;
  onToolDeleted: () => void;
}

export const DeleteToolModal: FC<DeleteToolModalProps> = ({
  isOpen,
  onClose,
  toolId,
  toolName,
  onToolDeleted,
}) => {
  const dispatch = useAppDispatch();
  const [deleteTool, { isLoading: isDeleting }] = useDeleteToolMutation();

  const handleDeleteTool = async () => {
    try {
      await deleteTool(toolId).unwrap();
      showNotification(dispatch, {
        id: `tool-delete-${new Date().getTime().toString()}`,
        type: NotificationType.SUCCESS,
        primaryMessage: "Tool deleted",
        secondaryMessage: `${toolName} has been deleted successfully.`,
      });
      onClose();
      onToolDeleted();
    } catch (error) {
      console.error("Failed to delete tool:", error);
      showNotification(dispatch, {
        id: `tool-delete-error-${new Date().getTime().toString()}`,
        type: NotificationType.FAILURE,
        primaryMessage: "Failed to delete tool",
        secondaryMessage: "Please try again.",
      });
    }
  };

  return (
    <SimpleModal
      isOpen={isOpen}
      variant={SimpleModalVariant.Warning}
      title="Delete tool"
      subtitle="Are you sure you want to delete this tool? This action cannot be undone."
      confirmButtonText="Delete tool"
      isPrimaryButtonLoading={isDeleting}
      onCancel={onClose}
      onConfirm={handleDeleteTool}
    />
  );
};
